<template>
  <b-container>
    <DiscoverTabs></DiscoverTabs>

    <b-row>
      <b-col>
        <div class="items">

          <div :class="itemClass" v-for="item in items" :key="item">
            <router-link :to="itemLink(item)">
              <div class="imgwrap">
                <img :src="getThumbnail(type, item)">
              </div>
              <div class="gradient" v-if="type !== 'instrument'">&nbsp;</div>
            </router-link>
            <div class="name">
              <router-link :to="itemLink(item)">{{ itemName(item) }}</router-link>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .items {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    @include media-breakpoint-down(lg) {
      justify-content: space-between;
    }
    @include media-breakpoint-down(xs) {
      justify-content: center;
    }

    .item.genre, .item.mood {
      margin-top: 1em;
      margin-right: 1em;
      position: relative;
      text-align: center;

      img {
        width: 200px;
        height: 200px;
        border: 10px solid $dark;
        @include media-breakpoint-down(sm) {
          width: 150px;
          height: 150px;
        }
        @include media-breakpoint-down(xs) {
          width: 100px;
          height: 100px;
        }
      }

      .gradient {
        position: absolute;
        top: 10px;
        left: 0px;
        width: 100%;
        height: 180px;
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, $dark);
        @include media-breakpoint-down(sm) {
          height: 130px;
        }
        @include media-breakpoint-down(xs) {
          height: 80px;
        }
      }

      .name {
        margin-top: 0.5em;
        display: block;
        text-align: center;
        font-weight: bold;

        /deep/ a {
          text-decoration: none;
          color: $white;
        }
        @include media-breakpoint-down(sm) {
          width: 150px;
        }
        @include media-breakpoint-down(xs) {
          font-size: .8em;
          width: 100px;
        }
      }

      &:hover {
        img {
          border-image: linear-gradient(to bottom, $darkish-pink, $blue-purple) 1;
          border-width: 10px;
          border-style: solid;
        }

        .gradient {
          background-image: linear-gradient(to bottom, rgba(220, 54, 129, 0) 50%, $blue-purple);
        }

      }
    }

    .item.instrument {
      margin-top: 1em;
      margin-bottom: 2em;
      margin-right: 1em;
      text-align: center;
      width: 150px;
      @include media-breakpoint-down(xs) {
        width: 90px;
      }

      .imgwrap {
        margin: 0 auto;
        background: $dark;
        width: 120px;
        height: 120px;
        padding: 30px;
        border-radius: 100%;
        @include media-breakpoint-down(xs) {
          width: 90px;
          height: 90px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        img {
          width: 100%;
          height: 100%;
          @include media-breakpoint-down(xs) {
            width: 50%;
            height: 50%;
          }
        }

      }

      .name {
        margin-top: 0.5em;
        display: block;
        text-align: center;
        font-weight: bold;

        /deep/ a {
          text-decoration: none;
          color: $white;
        }
        @include media-breakpoint-down(xs) {
          font-size: .9em;
        }
      }

      &:hover {
        .imgwrap {
          background: linear-gradient(to bottom, $darkish-pink, $blue-purple);
        }
      }
    }
  }
</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import DiscoverTabs from '@/components/widgets/DiscoverTabs'

import { genres, moods, instruments, getThumbnail } from '@/store/modules/tag'

const tags = {
  genre: genres,
  mood: moods,
  instrument: instruments
}

export default {
  name: 'DiscoverGenre',
  components: {
    FontAwesomeIcon,
    DiscoverTabs
  },
  computed: {
    type () {
      return this.$route.meta.type
    },
    itemClass () {
      return ['item', this.type]
    },
    items () {
      return tags[this.type]
    }
  },
  methods: {
    itemName (item) {
      return item.replace(/\//, ' / ')
    },
    itemLink (item) {
      return {
        name: 'discover-' + this.type + '-detail',
        params: {
          tag: item
        }
      }
    },
    getThumbnail: getThumbnail
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/discover/Browse.vue